import { render } from "./ImplantableDeviceRow.vue?vue&type=template&id=c2acb484"
import script from "./ImplantableDeviceRow.ts?vue&type=script&lang=js&external"
export * from "./ImplantableDeviceRow.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__